import {FC, useMemo} from 'react';
import {toast} from 'react-toastify';
//mui
import {Box} from '@mui/material';
//formik
import {Formik} from 'formik';
import {initialValues} from './formConfiguration';
//services
import {OrganizationContactService} from '@/utils/services';
//helpers
import {getErrorMessage} from '@/utils/helpers';
//components
import FormContent from './FormContent';
//types
import {IOrganizationContact} from '@/utils/types';
//styles
import {contactEditStyle} from './ContactEdit.styles';

interface ContactEditProps {
	detailsContact: IOrganizationContact | null;
	onModalClose: () => void;
}

const ContactEdit: FC<ContactEditProps> = ({detailsContact, onModalClose}) => {
	const submitClickHandler = async (values: Omit<IOrganizationContact, 'added' | 'edited'>) => {
		try {
			const {id, ...reqBody} = values;
			await OrganizationContactService.updateContact(id, reqBody);
			onModalClose();
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	const formikInitialValues = useMemo(() => {
		if (detailsContact) return detailsContact;
		return initialValues;
	}, [detailsContact]);

	return (
		<Box sx={contactEditStyle.wrapper}>
			<Formik enableReinitialize initialValues={formikInitialValues} onSubmit={submitClickHandler}>
				<FormContent onModalClose={onModalClose} />
			</Formik>
		</Box>
	);
};

export default ContactEdit;
